import { useDispatch,useSelector } from "react-redux";
import { setNavigatePath, setStorePreviousPaths } from "app/ducks/GlobalSlice";

const useNavigate = () => {
	const dispatch = useDispatch();
	const storePreviousPaths = useSelector((state) => state.ProspectWidgets_GlobalData?.storePreviousPaths);

	const navigate = (path, options) => {
		dispatch(setNavigatePath(path));
		if(storePreviousPaths) {
			if(!storePreviousPaths.includes(path)) dispatch(setStorePreviousPaths([...storePreviousPaths, ...[path]]));
		}else dispatch(setStorePreviousPaths([path]));
		const currentUrl = window.location.href;
		const newUrl = new URL(currentUrl);
		const searchParams = new URLSearchParams(newUrl?.search);
		if (searchParams.has("pageName")) {
			newUrl.searchParams.set("pageName", encodeURIComponent(path));
			window && window.history.pushState({}, "", newUrl);
		}
	};

	return navigate;
};

export default useNavigate;
